import { render, staticRenderFns } from "./aimodelrequest.vue?vue&type=template&id=0a4a9b12"
import script from "./aimodelrequest.vue?vue&type=script&lang=ts"
export * from "./aimodelrequest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports